export default function (options, dayjsClass) {
  const oldParse = dayjsClass.prototype.parse;
  dayjsClass.prototype.parse = function (config) {
    if (config.date === null) {
      config.date = NaN;
    }
    oldParse.bind(this)(config);
  };
}
